import axios from 'axios';
import { resolveAuthApiUrl } from './resolve-auth-api-url';
import { withSocialChannelHeaders } from './social-channel';

export interface CreateSocialConsumerPayload {
  fullName: string;
  id: string;
  password: string;
  username: string;
}

export interface SocialConsumerRepository {
  createConsumer(payload: CreateSocialConsumerPayload): Promise<{ status: number }>;
}

export function useSocialConsumerRepository(): SocialConsumerRepository {
  const createConsumer = async (payload: CreateSocialConsumerPayload) => {
    return axios.post(resolveAuthApiUrl('/consumer'), payload, {
      headers: withSocialChannelHeaders(
        {
          'Content-Type': 'application/json',
        },
        true,
      ),
    });
  };

  return { createConsumer };
}
